import Image from "next/image";

export default function FaxContactItem(props) {
  const { item } = props;
  return (
    <address className="flex flex-col w-full gap-2 relative">
      <h3 className="font-bold uppercase text-gray-700">{item.title}</h3>
      <div className="flex w-full h-full gap-4 relative items-center">
        <Image
          src="/svgs/fax-icon.svg"
          alt="icon"
          objectFit="contain"
          layout="fixed"
          width={30}
          height={20}
        />
        <p className="text-gray-500 transition-colors">{item.content}</p>
      </div>
    </address>
  );
}
